import moment from 'moment';

export class InformationsResult {
	public readonly id: string;
	public readonly organization_name: string;
	public readonly company_name: string;
	public readonly sector_name: string;
	public readonly line_name: string;
	public readonly workstation_name: string;
	public readonly activity_name: string;
	public readonly report_name: string;
	public readonly file_name: string;
	public readonly evaluator_name: string;
	public readonly analysis_date: string;
	public readonly collection_date: string;
	public readonly is_consolidated: boolean;

	constructor({
		id,
		organization_name,
		company_name,
		sector_name,
		line_name,
		workstation_name,
		activity_name,
		report_name,
		file_name,
		evaluator_name,
		analysis_date,
		collection_date,
		is_consolidated
	}: any) {
		this.id = id;
		this.organization_name = organization_name;
		this.company_name = company_name;
		this.sector_name = sector_name;
		this.line_name = line_name;
		this.workstation_name = workstation_name;
		this.activity_name = activity_name;
		this.report_name = report_name;
		this.file_name = file_name;
		this.evaluator_name = evaluator_name;
		this.analysis_date = analysis_date ? moment(analysis_date).format('L') : '';
		this.collection_date = collection_date ? moment(collection_date).format('L') : '';
		this.is_consolidated = !!is_consolidated;
	}
}
